import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_STORE_OPENING_TIMES_BY_ID } from '../../queries/get-store-opening-times-by-id.js';
import { fromStoreOpeningTimesByIdQueryToOpeningTimes } from './adapters/fromStoreOpeningTimesByIdQueryToOpeningTimes.js';

const useStoreOpeningTimesById = ()=>{
    const [query, queryState] = useLazyQuery(GET_STORE_OPENING_TIMES_BY_ID);
    const data = React.useMemo(()=>{
        var ref;
        return fromStoreOpeningTimesByIdQueryToOpeningTimes((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        query,
        queryState,
        data
    ]);
};

export { useStoreOpeningTimesById as default, useStoreOpeningTimesById };
//# sourceMappingURL=use-store-opening-times-by-id.js.map
